import { Controller } from "stimulus";
import InputMask from "inputmask";

export default class extends Controller {
  connect() {
    this.inputMask = new InputMask("a9999");
    this.inputMask.mask(this.element);
  }
}
